import { IDownloadControlePatrimonioByIdUseCase } from "../../../presentation/useCases/read/download_controle_patrimonio_by_id_use_case";
import { IRhRepository } from "../../repositories/rh_repository";


export class DownloadControlePatrimonioByIdUseCase implements IDownloadControlePatrimonioByIdUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async downloadControlePatrimonioById(
    idControlePatrimonio: number,
    imageName: string
  ): Promise<void> {
    const blob = await this.repository.downloadControlePatrimonioById(idControlePatrimonio);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(imageName));
    document.body.appendChild(link);
    link.click(); 
    
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
